import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CopModuleState, copModuleKey } from '../cop/cop.reducer';
import * as fromLists from './lists.reducer';

const selectCopModuleState = createFeatureSelector<CopModuleState>(copModuleKey);

const selectListsState = createSelector(selectCopModuleState, (state: CopModuleState) => state?.lists);

export const selectIsCardsVisible = createSelector(selectListsState, fromLists.getIsCardsVisible);
export const selectLoadedCards = createSelector(selectListsState, fromLists.getLoadedCards);
export const selectCardViewForDisplay = createSelector(selectListsState, fromLists.getCardViewForDisplay);
export const selectTableVisible = createSelector(selectListsState, fromLists.getIsTableVisible);
export const selectTableType = createSelector(selectListsState, fromLists.getTableType);
export const selectListQuery = createSelector(selectListsState, fromLists.getListQuery);
export const selectAssetsListQuery = createSelector(selectListsState, fromLists.getAssetsListQuery);
export const selectSelectListQuery = createSelector(selectListsState, fromLists.getSelectListQuery);
export const selectRelatedListQuery = createSelector(selectListsState, fromLists.getRelatedListQuery);

// Export Templates
export const selectExportTemplates = createSelector(selectListsState, fromLists.getExportTemplates);